export const TAB_KEYS = {
  FINANCIALS: 'financials',
  LISTING: 'listing',
  CONTACT_INFO: 'contactInfo',
} as const

export const tabItems = [
  { key: TAB_KEYS.FINANCIALS, label: 'Financials' },
  { key: TAB_KEYS.LISTING, label: 'Listings' },
  { key: TAB_KEYS.CONTACT_INFO, label: 'Contact Info' },
]
